import { render } from "./QuizType10.vue?vue&type=template&id=6c9df882&scoped=true"
import script from "./QuizType10.vue?vue&type=script&lang=js"
export * from "./QuizType10.vue?vue&type=script&lang=js"

import "./QuizType10.vue?vue&type=style&index=0&id=6c9df882&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9df882"]])

export default __exports__